/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Architect_Detail9Inputs */

const en_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access, monitoring and deploy paths set up once.`)
};

const ar_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول والمراقبة ومسارات النشر تجهز مرة واحدة.`)
};

const bn_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাক্সেস, মনিটরিং আর ডিপ্লয় পথ একবারে সেট করা।`)
};

const de_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang, Monitoring und Deploy-Wege einmalig einrichten.`)
};

const es_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso, monitorización y rutas de despliegue configurados una vez.`)
};

const fr_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès, supervision et chemins de déploiement configurés une fois.`)
};

const pt_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso, monitorização e rotas de deploy configurados uma vez.`)
};

const zh_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限、监控和发布通道一次配好。`)
};

const tr_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişim, izleme ve yayın yolları bir kez kurulur.`)
};

const ru_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ, мониторинг и пути деплоя настраиваются один раз.`)
};

const pl_svc_retainer_architect_detail9 = /** @type {(inputs: Svc_Retainer_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp, monitoring i ścieżki wdrożenia ustawione raz.`)
};

/**
* | output |
* | --- |
* | "Access, monitoring and deploy paths set up once." |
*
* @param {Svc_Retainer_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_architect_detail9 = /** @type {((inputs?: Svc_Retainer_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_retainer_architect_detail9(inputs)
	if (locale === "de") return de_svc_retainer_architect_detail9(inputs)
	if (locale === "es") return es_svc_retainer_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_retainer_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_retainer_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_retainer_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_retainer_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_retainer_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_retainer_architect_detail9(inputs)
	return en_svc_retainer_architect_detail9(inputs)
});
export { svc_retainer_architect_detail9 as "svc_retainer_ARCHITECT_detail" }